(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rdtv-product"]) return;
  try {
    
  function initializeRetroDialGallery(root){
    if(root.dataset.galleryReady)return;
    root.dataset.galleryReady='true';
    const image=root.querySelector('.rdtv-product__hero');
    const links=[...root.querySelectorAll('[data-rdtv-image]')];
    links.forEach(link=>link.addEventListener('click',event=>{if(!image)return;event.preventDefault();image.removeAttribute('srcset');image.src=link.href;image.alt=link.dataset.alt;links.forEach(item=>item.removeAttribute('aria-current'));link.setAttribute('aria-current','true');}));
  }
  document.querySelectorAll('.rdtv-product').forEach(initializeRetroDialGallery);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.rdtv-product').forEach(initializeRetroDialGallery));

  } catch(e) { console.error(e); }
})();
})();
